// eslint-disable-next-line import/prefer-default-export
export const initialValues = {
  printerCopies: '',
};

export type FormValues = typeof initialValues;
